export const ORGANIZATION_TYPES = [
  { label: 'Bank', value: 'bank' },
  { label: 'Credit union', value: 'credit_union' },
  { label: 'Other', value: 'other' },
];
export const RATE_TYPES = ['adjustable', 'variable', 'fixed', 'balloon'];

export const DEBOUNCE_DELAY = 500;
